import requests from "./httpService";

const BlogServices = {
  // Fetch all blogs
  getBlogs: async () => {
    return await requests.get(`/blogs`);
  },

  // Fetch a single blog by id (if needed)
  getBlogById: async (id) => {
    return await requests.get(`/blogs/${id}`);
  },
  getWebBlog: async () => {
    return requests.get(`/blogs`);
  },
  getBlogByTitle: async (title) => {
    return await requests.get(`/blogs?title=${encodeURIComponent(title)}`);
  },

  // Create a new blog
  createBlog: async (body) => {
    return await requests.post(`/blogs`, body);
  },

  // Update an existing blog by id
  updateBlog: async (id, body) => {
    return await requests.patch(`/blogs/${id}`, body);
  },

  // Delete a blog by id
  deleteBlog: async (id) => {
    return await requests.delete(`/blogs/${id}`);
  },
};

export default BlogServices;
